var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "24 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default no-stroke",
    transform: "translate(30.05 1.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 9.1c.3 0 .5.2.5.5l.1 9.4h2.6l-.1-9.4c0-.1.1-.3.1-.4.1-.1.2-.1.4-.1H11V7.4H7.7c-.3 0-.5-.2-.5-.5V5.3C7.2 4 8 2.8 10 2.8h1V1H8.4C8.2 1 5.3.9 4.6 3.9c0 0-.3.9-.2 3 0 .1 0 .3-.1.4s-.2.2-.4.2H1.1v1.6h3zM4.2 20c-.3 0-.5-.2-.5-.5l-.1-9.4H.5c-.3 0-.5-.2-.5-.5V7c0-.1.1-.3.1-.4.1-.1.2-.1.4-.1h2.8c0-1.9.3-2.8.3-2.8C4.5-.1 8.4.1 8.4.1h3c.3 0 .5.2.5.5v2.8c0 .3-.2.5-.5.5H9.9c-1.3 0-1.8.8-1.8 1.5v1.1h3.3c.2 0 .3.1.4.1.1.1.1.2.1.4v2.7c0 .3-.2.5-.5.5H8.1l.1 9.4c0 .1-.1.3-.1.4-.1.1-.2.1-.4.1L4.2 20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3 8.4h-3.1V7.3c0-.4.1-.8.4-1 .3-.3.8-.5 1.4-.5h1.5c.3 0 .5-.2.5-.5V2.5c0-.3-.2-.5-.5-.5h-3s-3.9-.2-4.8 3.6c0 0-.3.9-.3 2.8h-2.8c-.1 0-.3.1-.4.1-.1.1-.1.2-.1.4v2.6c0 .1.1.3.1.4.1.1.3.2.4.1h3.1l.1 9.4c0 .3.2.5.5.5h3.6c.1 0 .3-.1.4-.1.1-.1.1-.2.1-.4l-.1-9.4h3.1c.1 0 .3-.1.4-.1.1-.1.1-.2.1-.4V8.9c-.1-.3-.3-.5-.6-.5"
  }))));
}
SvgFacebook.displayName = 'Facebook';
export default SvgFacebook;